import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from "@chakra-ui/react";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ModeloItemOrcamento } from "models/modelo_item_orcamento";
import { ModeloItemOrcamentoCategoria } from "models/modelo_item_orcamento_categoria";
import { ModeloItemOrcamentoProduto } from "models/modelo_item_orcamento_produto";
import TemplateData from "./TemplateData";

interface IFormTemplate {
  itens: ModeloItemOrcamentoCategoria[] | undefined;
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: ModeloItemOrcamento;
  error: boolean;
  textColor: string;
  brandStars: string;
  nome: string;
  changeNome: (value: string) => void;
  loading: boolean;
  save: () => void;
  deleteRow: (item: ModeloItemOrcamentoCategoria) => void;
  addRow: (item: ModeloItemOrcamentoCategoria) => void;
  borderColor: string;
  errorTitle: string;
  errorMsg: string;
  cancelRef: any;
  closeError: () => void;
  showItemModal: (item: boolean) => void;
  showCategory: boolean;
  saveItem: () => void;
  changeItem: (item: ModeloItemOrcamentoCategoria) => void;
  removeItem: (item: ModeloItemOrcamentoCategoria) => void;
  nomeRef: any;
  reorder: (
    list: ModeloItemOrcamentoCategoria[],
    startIndex: number,
    endIndex: number
  ) => void;
  drag: boolean;
  isDragable: (drag: boolean) => void;
  condicaoPagamento: CondicaoPagamento[] | undefined;
  itemList: ModeloItemOrcamentoProduto[];
  addRowItem: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
  editRow: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void;
  deleteRow1: (item: ModeloItemOrcamentoProduto, categ: ModeloItemOrcamentoCategoria) => void
}

const FormTemplate = ({
  showModal,
  accountSelected,
  error,
  show,
  textColor,
  brandStars,
  changeNome,
  save,
  loading,
  addRow,
  borderColor,
  cancelRef,
  changeItem,
  closeError,
  deleteRow,
  errorMsg,
  errorTitle,
  itens,
  nome,
  showItemModal,
  showCategory,
  saveItem,
  nomeRef,
  drag,
  isDragable,
  removeItem,
  reorder,
  condicaoPagamento,
  addRowItem,
  editRow,
  itemList,
  deleteRow1
}: IFormTemplate) => {
  return (
    <>
      <Box>
        <Box>
          <FormControl isInvalid={error}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Descrição<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              defaultValue={accountSelected?.nome}
              isRequired={true}
              variant="auth"
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o nome do Item"
              onChange={(e) => changeNome(e.target.value)}
              mb="24px"
              fontWeight="500"
              size="lg"
            />
            {error && (
              <FormErrorMessage>
                Preencha Corretamente o Campo.
              </FormErrorMessage>
            )}
          </FormControl>

          <Text
            textAlign="left"
            color={"black"}
            fontWeight={"bold"}
            fontSize={16}

          >
            Grupos
            <TemplateData
              showItemModal={showItemModal}
              showCategory={showCategory}
              changeItem={changeItem}
              brandStars={brandStars}
              nomeRef={nomeRef}
              saveItem={saveItem}
              textColor={textColor}
              itens={itens}
              drag={drag}
              isDragable={isDragable}
              removeItem={removeItem}
              reorder={reorder}
              borderColor={borderColor}
              condicaoPagamento={condicaoPagamento}
              addRowItem={addRowItem}
              deleteRow={deleteRow1}
              editRow={editRow}
              itemList={itemList}
            />
          </Text>
        </Box>
        <Box>
          <Button
            onClick={() => {
              showModal(false);
            }}
            variant="outline"
            marginRight={4}
          >
            Fechar
          </Button>
          <Button
            onClick={() => {
              save();
            }}
            colorScheme="brand"
            isLoading={loading}
          >
            Salvar
          </Button>
        </Box>
      </Box>

      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default FormTemplate;
